import React from "react";
import { Modal } from "react-bootstrap";
import { MediaBaseUrl } from "../../../../../actions/api";
import { windowOpen } from "../../../../../utils";

const PaymentStatus = ({ onHide, details, loading, paymentAction, getAnotherPlan, shareEmailPop, updateUserData }) => {
    const { showDetails, data, type } = details;
    return <Modal show={showDetails}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        className="payment-pending no-header"
        aria-labelledby="contained-modal-title-vcenter"
        centered >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="py-4">
            <div className="row">
                <div className="col-12">
                    {type < 4 ? <PaymentCompleted isFailed={type == 3} invoiceUrl={data?.url ?? null} shareEmailPop={shareEmailPop} updateUserData={updateUserData} /> : <PaymentProcess {...{ isDowngrade: type == 5, getAnotherPlan, data, onHide, loading, paymentAction }} />}
                </div>
            </div>
        </Modal.Body>
    </Modal>
}

export default PaymentStatus;

const PaymentCompleted = ({ isFailed, invoiceUrl, shareEmailPop, updateUserData }) => {
    return <div className="payment-failed text-center pb-3">
        <div className="mb-3">
            <img src={`${MediaBaseUrl}images/${isFailed ? "payment-failed" : "payment-success"}.png`} alt={isFailed ? "payment-failed" : "payment-success"} className="img-fluid" />
        </div>
        <h2>{isFailed ? "Additional Action Required " : "Payment Successful!"}</h2>
        <p className="mx-auto">{isFailed ? "It seems we couldn't process your payment automatically. Additional action is required to complete the payment." : "Thank you for your payment! Your transaction has been processed successfully."}</p>
        {invoiceUrl ? <button className="btn btn-primary" onClick={() => updateUserData(() => windowOpen(invoiceUrl, "_blank"))}>{isFailed ? "Pay Now" : "View Invoice"}</button> : null}
        {isFailed ? <p className="more-information mx-auto">Want to receive the payment link via email? <span onClick={() => updateUserData(shareEmailPop)}>Click here</span></p> : null}
    </div>
}

const PaymentProcess = ({ isDowngrade, data, onHide, loading, paymentAction, getAnotherPlan }) => {
    const initialPayment = (url) => isDowngrade ? paymentAction() : url ? windowOpen(url, "_blank") : null;
    const downgradeType = isDowngrade ? data?.isUpgradeType ?? 0 : 0; // 0 --> credit // 2 --> payextra

    return <div className="payment-failed text-center">

        <div className={`payment-icon-section d-flex align-items-center justify-content-center mx-auto ${isDowngrade ? downgradeType == 0 ? 'pis-success' : '' : ''}`}><img src={`${MediaBaseUrl}images/${isDowngrade ? `payment-pending` : `paid-billing-upgrade`}.png`} alt={isDowngrade ? "paid-billing" : "payment-pending"} className="img-fluid" /></div>

        <h2>{isDowngrade ? downgradeType == 2 ? 'Level up your website with more features!' : `Are you sure you want to downgrade?` : `Your payment is still pending for '${data?.currentPlanName ?? ""}'`}</h2>

        {isDowngrade ? <p className="mb-0 mx-auto">{downgradeType == 2 ? `Enjoy access to all the advanced features ${data?.upgradedPlanName ?? ""} offers by switching to subscription.` : `Switching to the ${data?.upgradedPlanName ?? ""} Plan will limit some of the powerful features you're currently using on the ${data?.currentPlanName ?? ""} Plan.`}</p> : null}

        <div className={`actions ${isDowngrade ? downgradeType == 2 ? 'my-0': 'mt-0 mb-0': 'my-0'}`}>
            <button className={`btn btn-${(downgradeType == 0) ? "secondary" : "primary"} ${loading ? 'spinner spinner-right disabled' : ''} me-3`} onClick={loading ? null : () => initialPayment(data?.currPaymentUrl ?? null)}>{isDowngrade ? "Yes, Go ahead" : "Complete Payment Now"}</button>
            {isDowngrade && (downgradeType == 0) ? <button className="btn btn-primary" onClick={onHide}>No, I have changed my mind</button> : null}
        </div>

        <p className={`mb-5 more-information mx-auto ${isDowngrade ? '' : 'continue-with'}`}>{isDowngrade ? <><em>*</em> Your already paid amount will automatically be adjusted in your billing.</> : <span onClick={loading ? null : () => getAnotherPlan(data?.planId ?? null)}>Continue with '{data?.upgradedPlanName ?? ""}'</span>}</p>
    </div>
}